module.exports = __webpack_public_path__ + "static/media/stars-1366.b86bb4a1.webp";